import React from "react";
import { Modal, Row, Col, Button, Input } from "antd";

const RowDetailModal = ({ title, visible, onClose, columns, record, onRemarkChange }) => {
  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "20px",
            borderBottom: "1px solid black",
            paddingBottom: "2px",
          }}
        >
          <span>{title ? title : "Details"}</span>
          <Button
            danger
            onClick={onClose}
            disabled = {record?.employment_status == "separated" ?  true: false}
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              paddingRight: "0px",
              marginRight: "-3px",
              marginTop: "-7px",
            }}
          >
            <i
              className="fa-solid fa-xmark"
              style={{ color: "red", fontSize: "20px" }}
            ></i>
          </Button>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <div key="footer" className="d-flex gap-2 justify-content-end">
          {columns[columns.length - 1].render
            ? columns[columns.length - 1].render(
                record[columns[columns.length - 1].dataIndex],
                record
              )
            : record[columns[columns.length - 1].dataIndex]}
        </div>,
      ]}
    >
      <Row gutter={[16, 16]}>
        {columns.slice(0, -1).map((col, index) => {
          if (col.dataIndex || col.render) {
            if (col.dataIndex === "remark") {
              // Only show remark if the column is present and the value is not null/undefined
              if (typeof record.remark === "undefined" || record.remark === null) {
                return null;
              }
              return (
                <Col key={col.key || index} span={24}>
                  <strong>{col.title}:</strong>
                  <div>
                    <Input.TextArea
                      rows={3}
                      placeholder="Enter your remark here"
                      value={record.remark || ""}
                      onChange={(e) => onRemarkChange(record.key, e.target.value)}
                    />
                  </div>
                </Col>
              );
            }
            // For other columns, only show if value is not null/empty string
            return (
              record[col.dataIndex] !== null &&
              record[col.dataIndex] !== "" && (
                <Col
                  key={col.key || index}
                  span={index === columns.length - 2 ? 24 : 8}
                >
                  <strong>{col.title}:</strong>
                  <div>
                    {col.render ? (
                      col.render(record[col.dataIndex], record)
                    ) : (
                      record[col.dataIndex]
                    )}
                  </div>
                </Col>
              )
            );
          }
          return null;
        })}
      </Row>
    </Modal>
  );
};

export default RowDetailModal;